'use client';

import { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import {
  BlogArticleDocumentDataContentItem,
  Simplify,
} from '../../../../../../../../../prismicio-types';

import styles from './articleTable.module.scss';

interface ArticleTableProps {
  content: Simplify<BlogArticleDocumentDataContentItem>[];
  title: RichTextField;
  offsetElement: string;
}

const components: JSXMapSerializer = {
  heading5: ({ children }) => <h5 className={styles.title}>{children}</h5>,
};

const OFFSET = 84;

export const ArticleTable = ({
  title,
  content,
  offsetElement,
}: ArticleTableProps) => {
  const handleScrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - OFFSET;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };
  return (
    <div className={styles.table}>
      <PrismicRichText field={title} components={components} />
      <div className={styles.list_wrapper}>
        <ul className={styles.list}>
          {content.map((item, index) => {
            const firstNode = item.heading?.[0];
            const headingText =
              firstNode && 'text' in firstNode
                ? firstNode.text
                : `section-${index}`;

            return (
              <li
                key={`${headingText}-${index}`}
                className={`${offsetElement === headingText ? styles.isActive : styles.oppasity} ${styles.item}`}
              >
                <button
                  onClick={() => handleScrollTo(headingText)}
                  className={styles.button}
                  type="button"
                >
                  <PrismicRichText field={item.heading} />
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
